export const qkBaseGmail = ['gmail']

//getAuthAccount
export const qkGetAuthAccount = (factorId: string) => [...qkBaseGmail, 'authorized-account', factorId]
